import { useNavigate, useParams } from "react-router-dom";
import {
  Tabs,
  TabsContent,
  TabsListWithIndicator,
  TabsTrigger,
} from "@/core/components/ui/tabs";
import { SIDEBAR_MODES, SIDEBAR_SECTIONS } from "@/business-settings/constants";
import { useBusinessSettingsSidebar } from "@/business-settings/context/business-settings-sidebar-context";
import { useGetInternalTransactions } from "@/internal-transactions/query";
import { useGetPayouts } from "@/payouts/query";
import { InternalTransactions } from "./internal-transactions";
import { ReferralPayments } from "./referral-payments";

const PaymentsTable = () => {
  const { updateSidebar } = useBusinessSettingsSidebar();
  const navigate = useNavigate();
  const { businessId, tab } = useParams();
  const activeTab = tab ?? SIDEBAR_SECTIONS.referralPayments;

  const { data: referralPayouts, isLoading: isReferralPayoutsLoading } =
    useGetPayouts(businessId);
  const {
    data: internalTransactions,
    isLoading: isInternalTransactionsLoading,
  } = useGetInternalTransactions(businessId);

  const referralPaymentsCount = referralPayouts?.length ?? 0;
  const internalTransactionsCount = internalTransactions?.length ?? 0;

  const handleTabChange = (tab: string) => {
    updateSidebar({
      selectedItemId: undefined,
      mode: SIDEBAR_MODES.view,
      section:
        tab === SIDEBAR_SECTIONS.referralPayments
          ? SIDEBAR_SECTIONS.referralPayments
          : SIDEBAR_SECTIONS.internalTransactions,
      isOpen: false,
    });
    navigate(`/business-settings/${businessId}/payments/${tab}`);
  };

  return (
    <Tabs
      value={activeTab}
      onValueChange={handleTabChange}
      className="flex w-full flex-1 flex-col overflow-hidden"
    >
      <TabsListWithIndicator
        className="w-full justify-start"
        containerClassName="mr-5"
      >
        <TabsTrigger
          isCountLoading={isReferralPayoutsLoading}
          count={referralPaymentsCount}
          value={SIDEBAR_SECTIONS.referralPayments}
        >
          Referral Payments
        </TabsTrigger>
        <TabsTrigger
          isCountLoading={isInternalTransactionsLoading}
          count={internalTransactionsCount}
          value={SIDEBAR_SECTIONS.internalTransactions}
        >
          Internal Transactions
        </TabsTrigger>
      </TabsListWithIndicator>
      <TabsContent
        value={SIDEBAR_SECTIONS.referralPayments}
        className="flex-1 overflow-hidden pt-2"
      >
        <ReferralPayments businessId={businessId} />
      </TabsContent>
      <TabsContent
        value={SIDEBAR_SECTIONS.internalTransactions}
        className="flex-1 overflow-hidden pt-2"
      >
        <InternalTransactions />
      </TabsContent>
    </Tabs>
  );
};

export default PaymentsTable;
